
export default function Footer() {
  return (
    <footer className="bg-rose-soft py-6 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-3">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/2dcf709829f9212ac45256ebe1ad3ecc/891be6a404883ecf815eda4d9f86e41c.png" 
              alt="Pizz'Ajo Logo" 
              className="w-8 h-8 object-contain"
            />
            <p className="text-dark/50 text-xs">
              © 2026 Pizz'Ajo. Tous droits réservés.
            </p>
          </div>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-dark/40 hover:text-terracotta text-xs transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
